import { css } from "@emotion/css";
import { ContactButton } from "@/lib/nemmp/base";
import { getWebsiteLayout } from "@/modules/navigation/website-layout/WebsiteLayout";
import Head from "next/head";
import { appConfig } from "../config/app-config";
import { PageTitle } from "@/lib/mui/PageTitle";
import { NextPageWithLayout } from "./_app";
import { PageLayout } from "../modules/navigation/website-layout/PageLayout";

const Page: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>Imprint – {appConfig.name}</title>
      </Head>

      <PageLayout>
        <PageTitle>Imprint</PageTitle>

        <section>
          Levente-László Bagi Software-Entwickler
          <br />
          Stendaler Str. 77
          <br />
          12627 Berlin
          <br />
          Germany
        </section>

        <section
          className={css`
            margin-top: 1em;
          `}
        >
          <ContactButton variant="contained" />
        </section>
      </PageLayout>
    </>
  );
};

Page.getLayout = getWebsiteLayout;

export default Page;
